export const ImageSizer = ( heroImageUrl: string, width = window.innerWidth, height = window.innerHeight ) => {
        const ratio = window.devicePixelRatio;
        const displayWidth = ratio > 2 ? width * 2 : width;

        return `${ heroImageUrl }?width=${ displayWidth }`;
};

export default ImageSizer;
